import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SectionHeading from '../components/SectionHeading';
import { FadeUp } from '../components/Reveal';
import { portfolio } from '../data/site';

export default function Portfolio() {
  return (
    <>
      <PageHeader
        index="04"
        eyebrow="Portfólio de Obras"
        title="Obras entregues com rigor, acabamento e ART"
        description="Seleção de projetos executados pelo Grupo Majo: retrofit corporativo, infraestrutura, design de interiores e acessibilidade."
      />

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-28" data-testid="portfolio-grid">
        <div className="space-y-24 lg:space-y-32">
          {portfolio.map((p, i) => (
            <FadeUp key={p.title}>
              <article className={`grid items-center gap-10 lg:grid-cols-12 lg:gap-14`} data-testid={`portfolio-item-${i}`}>
                <FadeUp delay={0.1} className={`lg:col-span-7 ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="group relative overflow-hidden rounded-3xl border border-line shadow-[0_40px_90px_-40px_rgba(13,33,69,0.5)]">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                      data-testid={`portfolio-image-${i}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/50 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" aria-hidden="true" />
                    <span className="absolute right-5 top-5 rounded-full border border-white/20 bg-navy/80 px-4 py-1.5 text-[11px] font-bold uppercase tracking-widest text-white backdrop-blur-sm">
                      {p.status}
                    </span>
                  </div>
                </FadeUp>
                <div className={`lg:col-span-5 ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <FadeUp delay={0.2}>
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-display text-[11px] font-bold uppercase tracking-[0.22em] text-azure dark:text-gold-light">{p.category}</span>
                    </div>
                    <span className="mt-4 block font-display text-6xl font-extrabold leading-none outline-numeral" aria-hidden="true">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <h2 className="mt-3 font-display text-2xl font-bold leading-snug text-navy dark:text-white md:text-3xl">{p.title}</h2>
                    <div className="mt-6 space-y-4">
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold">Escopo Técnico</p>
                        <p className="mt-1.5 text-sm leading-relaxed text-muted-c">{p.scope}</p>
                      </div>
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold">Resultado Entregue</p>
                        <p className="mt-1.5 text-sm leading-relaxed text-muted-c">{p.outcome}</p>
                      </div>
                    </div>
                    <Link to="/simulador" data-testid={`portfolio-cta-${i}`} className="mt-7 inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-azure transition-colors hover:text-gold dark:text-gold-light dark:hover:text-gold">
                      Quero algo assim <ArrowUpRight size={15} />
                    </Link>
                  </FadeUp>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="border-t border-line bg-[var(--surface)] py-20" data-testid="portfolio-cta-band">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <FadeUp>
            <SectionHeading
              align="center"
              eyebrow="Próxima Obra"
              title="A sua obra pode ser a próxima história de sucesso"
              description="Conte o que você precisa no simulador e receba uma proposta técnica formatada no WhatsApp."
            />
            <Link to="/simulador" data-testid="portfolio-cta-band-link" className="btn-gold mt-9">
              Simular meu orçamento <ArrowRight size={16} />
            </Link>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
